import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import LandingPage from './pages/LandingPage';
import AllComponentsPage from './pages/AllComponentsPage';
import ComponentsPage from './pages/ComponentsPage';
import NavbarShowcase from './pages/NavbarShowcase';
import CreativesListPage from './pages/CreativesListPage';
import CreativeViewPage from './pages/CreativeViewPage';
import StrangerThingsLanding from './pages/StrangerThingsLanding';
import './App.css';

import { Analytics } from "@vercel/analytics/react";
import { HelmetProvider } from 'react-helmet-async';

function AppContent() {
  const location = useLocation();
  // Hide footer on individual component pages (e.g., /components/grid-background)
  const isComponentDetailPage = location.pathname.startsWith('/components/') && location.pathname !== '/components' && location.pathname !== '/components/';
  // Hide navbar and footer on individual creative pages (e.g., /creatives/blanket-ghost)
  const isCreativeViewPage = location.pathname.startsWith('/creatives/') && location.pathname !== '/creatives' && location.pathname !== '/creatives/';

  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      {!isCreativeViewPage && !isComponentDetailPage && <Navbar />}
      <Analytics />
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/components" element={<AllComponentsPage />} />
          <Route path="/components/:slug" element={<ComponentsPage />} />
          <Route path="/navbars" element={<NavbarShowcase />} />
          <Route path="/stranger-things" element={<StrangerThingsLanding />} />
          <Route path="/creatives" element={<CreativesListPage />} />
          <Route path="/creatives/:slug" element={<CreativeViewPage />} />
        </Routes>
      </div>
      {!isComponentDetailPage && !isCreativeViewPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
